import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import ListItem from '@mui/material/ListItem'
import Typography from '@mui/material/Typography'
import { KNBulletList } from 'components/KNBulletList/KNBulletList'
import { analyticsEvent } from 'global/helpers/analytics'
import useDialog from 'global/hooks/useDialog'
import useSuppressFlag from 'global/hooks/useSuppressFlag'
import { type ReactElement, useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import RequestAccountDialog from 'screens/Weblink/RequestAccountDialog'

export interface RequestAccountPromoProps {
  weblinkToken: string
}

const RequestAccountPromo = ({ weblinkToken }: RequestAccountPromoProps): ReactElement => {
  const { t } = useTranslation()
  const { suppressForDays } = useSuppressFlag('skip-request-account')
  // const [showPromo, setShowPromo] = useState(!isSuppressed)
  const [showPromo, setShowPromo] = useState(false) // popup temporarily disabled

  const handleRequestAccountClose = useCallback((): void => {
    if (showPromo) {
      suppressForDays(7)
      setShowPromo(false)
      analyticsEvent('polestar_cs_account_request_skipped')
    }
  }, [showPromo, suppressForDays])
  const requestAccountDialog = useDialog<typeof RequestAccountDialog>({
    onClose: handleRequestAccountClose,
  })

  useEffect(() => {
    if (showPromo) {
      requestAccountDialog.handleOpen()
    }
  }, [showPromo, requestAccountDialog.handleOpen])

  return (
    <>
      <Box>
        <Typography color="primary.main" component="p" variant="p4">
          {t('screens.cs.weblink.request_account_promo.intro')}
        </Typography>
        <KNBulletList sx={{ color: 'primary.main', fontSize: '0.875rem' }}>
          <ListItem>{t('screens.cs.weblink.request_account_promo.bullet_1')}</ListItem>
          <ListItem>{t('screens.cs.weblink.request_account_promo.bullet_2')}</ListItem>
          <ListItem>{t('screens.cs.weblink.request_account_promo.bullet_3')}</ListItem>
        </KNBulletList>
        <Typography color="primary.main" component="p" variant="p3">
          {t('screens.cs.weblink.request_account_promo.outro')}
        </Typography>
        <Button
          onClick={requestAccountDialog.handleOpen}
          fullWidth
          variant="contained"
          color="secondary"
          size="small"
          sx={{
            marginTop: 2,
          }}
        >
          {t('screens.cs.weblink.request_account.request_account')}
        </Button>
      </Box>

      <RequestAccountDialog
        payload={{
          weblinkToken,
          promo: showPromo,
        }}
        open={requestAccountDialog.isOpen}
        onAction={requestAccountDialog.handleAction}
        onClose={requestAccountDialog.handleClose}
      />
    </>
  )
}

export default RequestAccountPromo
